<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="trackings-form">
    <el-col :span="24">
      <span>Creado por: <b>{{ profile.name }}</b></span>
    </el-col>
    <el-col :span="8">
      <p>Fecha</p>
      <span>{{ today.format('DD/MM/ YYYY') }}</span>
    </el-col>
    <el-col :span="8">
      <p>Hora</p>
      <span>{{ today.format('h:mm') }}</span>
    </el-col>
    <el-form
      ref="formTracking"
      :model="model"
      :rules="rules"
      label-width="80px"
      label-position="top"
      @submit.native.prevent="onSubmit">
      <el-col :span="12">
        <el-form-item
          label="Tipo"
          prop="type">
          <el-select
            v-model="model.type"
            placeholder="Elija una opcion">
            <el-option
              v-for="(item, index) in optionsType"
              :key="index"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="Comentario"
          prop="title">
          <el-input
            v-model="model.title"
            placeholder="Comentario de la actividad"/>
        </el-form-item>
      </el-col>
      <el-col v-if="isOpportunity">
        <el-form-item
          label="Oportunidad"
          prop="opportunityId">
          <el-select
            v-model="model.opportunityId"
            placeholder="Elija una opcion">
            <el-option
              v-for="(opportunity, index) in opportunitiesItems"
              :key="index"
              :label="opportunity.title"
              :value="opportunity.id"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="Descripción"
          prop="notes">
          <el-input
            v-model="model.notes"
            :rows="4"
            resize="none"
            type="textarea"/>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Completada"
          prop="completed">
          <el-switch v-model="model.completed"/>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Recordatorio"
          prop="reminder">
          <el-switch v-model="model.reminder"/>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Siguiente fecha de contacto"
          prop="dueDate">
          <el-date-picker
            :disabled="model.completed"
            v-model="model.dueDate"
            :picker-options="pickerOptions"
            type="date"
            placeholder="Ingrese una fecha"/>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          prop="phase"
          label="Etapa">
          <el-select
            v-model="model.phase"
            placeholder="Elije una etapa">
            <el-option
              label="Propuesta"
              value="PROPOSAL"/>
            <el-option
              label="Negociación"
              value="NEGOTIATION"/>
            <el-option
              label="Cierre de venta"
              value="CLOSING_OF_SALE"/>
            <el-option
              label="Entrega de producto"
              value="PRODUCT_DELIVERY"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="Estatus de la oportunidad">
          <template v-for="status in opportunityStatus">
            <el-radio
              v-if="status.name != 'En Proceso'"
              :key="status.id"
              v-model="oportunity.status"
              :label="status.name">{{ status.name }}</el-radio>
          </template>
        </el-form-item>
      </el-col>
      <el-col
        v-if="oportunity.status === 'Rechazada'"
        :span="24">
        <el-form-item>
          <el-select
            v-model="select"
            placeholder="¿Por qué?"
            @change="onChangeSelect">
            <el-option
              label="Precio"
              value="Precio"/>
            <el-option
              label="Disponibilidad"
              value="Disponibilidad"/>
            <el-option
              label="Competencia"
              value="Competencia"/>
            <el-option
              label="Financiamiento"
              value="Financiamiento"/>
            <el-option
              label="Calidad"
              value="Calidad"/>
            <el-option
              label="Otro"
              value="otro"/>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="other"
          label="¿Cuál?">
          <el-input
            v-model="oportunity.reasonRejection"
            type="textarea"/>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-button
          type="primary"
          native-type="submit">
          Guardar
        </el-button>
      </el-col>
    </el-form>
  </el-row>
</template>

<script>
import trackingModel from '@/models/trackings/trackings-model'
import moment from 'moment'
import http from '@/services/http.service'

export default {
  name: 'TracingsCreate',
  props: {
    currentOpportunity: {
      type: Object,
      default: null
    },
    update: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: null
    },
    isFinal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpportunity: false,
      opportunitiesItems: [],
      opportunityStatus: [],
      model: trackingModel.model(),
      rules: trackingModel.rules(),
      today: moment(),
      select: '',
      other: false,
      valueType: '',
      optionsType: [
        {
          value: 'EMAIL',
          label: 'Correo Electrónico'
        },
        {
          value: 'CALL',
          label: 'Llamada'
        },
        {
          value: 'VISIT',
          label: 'Visita'
        },
        {
          value: 'QUOTATION',
          label: 'Cotización'
        },
        {
          value: 'DEMO',
          label: 'Demo'
        },
        {
          value: 'CREDIT',
          label: 'Crédito'
        }
      ],
      fullscreenLoading: false,
      oportunity: {
        status: null,
        reasonRejection: null
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < moment().subtract(1, 'days').toDate()
        }
      }
    }
  },
  computed: {
    tracking () {
      if (this.update) {
        return this.$store.getters['trackings/item']
      } else {
        return false
      }
    },
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    if (this.currentOpportunity !== undefined) {
      this.isOpportunity = false
      this.model.opportunityId = this.currentOpportunity.id
    } else {
      this.isOpportunity = true
    }

    http
      .get(process.env.API_URL + 'opportunities?filters[where][customerId][eq]=' + parseInt(this.customer.id))
      .then(response => {
        this.opportunitiesItems = response.data.items
      }).catch(error => {
        return Promise.reject(error)
      })

    http
      .get(process.env.API_URL + 'opportunity-status')
      .then(response => {
        this.opportunityStatus = response.data.items
      }).catch(error => {
        return Promise.reject(error)
      })

    if (this.update) {
      this.model = this.tracking
      this.oportunity.status = this.currentOpportunity.status
      this.oportunity.reasonRejection = this.currentOpportunity.reasonRejection
    }
  },
  methods: {
    onSubmit () {
      if (this.oportunity.status === 'Aceptada') {
        this.$confirm('¿Está seguro que su proceso de venta concluye en este momento?', 'Warning', {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.$refs['formTracking'].validate((valid) => {
            if (valid) {
              this.$store.dispatch('trackings/save', this.model)
                .then(response => {
                  this.$message.success(`Seguimiento ${this.update ? 'editado' : 'creado'} con éxtio`)
                  // if (this.update || this.oportunity.status) {
                  let oportunity = this.currentOpportunity
                  if (this.oportunity.status) {
                    oportunity.status = this.oportunity.status
                  }
                  if (this.oportunity.reasonRejection) {
                    oportunity.reasonRejection = this.oportunity.reasonRejection
                  }
                  if (!this.update || (this.update && this.isFinal)) {
                    oportunity.phase = response.data.phase
                  }
                  oportunity.quantity = parseInt(this.currentOpportunity.quantity)
                  this.$store.dispatch('opportunities/save', oportunity)
                    .then(response => {
                      this.$store.dispatch('app/toggleTrackingPanel')
                      this.$store.dispatch('trackings/query', {
                        'filters[where][opportunityId][eq]': this.currentOpportunity.id,
                        sort: 'dueDate asc',
                        limit: 1000
                      })
                      this.$store.dispatch('opportunities/query', {
                        ...this.$route.query,
                        'filters[where][customerId][eq]': this.customer.id
                      })
                      this.$store.dispatch('opportunities/get', { id: this.currentOpportunity.id })
                    })
                })
                .catch(error => {
                  this.$notify.error({
                    group: 'app',
                    title: 'Error al crear seguimiento.',
                    message: 'Por favor, vuelve a intentarlo.'
                  })
                  return Promise.reject(error)
                })
              this.fullscreenLoading = true
              setTimeout(() => {
                this.fullscreenLoading = false
              }, 2000)
            } else {
              this.$notify.error({
                group: 'app',
                title: 'Verifica el formulario.',
                message: 'Por favor, revisa los errores que se indican dentro del formulario.'
              })
              return false
            }
          })
        }).catch(() => {
        })
      } else {
        this.$refs['formTracking'].validate((valid) => {
          if (valid) {
            this.$store.dispatch('trackings/save', this.model)
              .then(response => {
                this.$message.success(`Seguimiento ${this.update ? 'editado' : 'creado'} con éxtio`)
                let oportunity = this.currentOpportunity
                if (this.oportunity.status) {
                  oportunity.status = this.oportunity.status
                }
                if (this.oportunity.reasonRejection) {
                  oportunity.reasonRejection = this.oportunity.reasonRejection
                }
                if (!this.update || (this.update && this.isFinal)) {
                  oportunity.phase = response.data.phase
                }
                oportunity.quantity = parseInt(this.currentOpportunity.quantity)
                if (this.oportunity.status) {
                  this.$store.dispatch('opportunities/save', oportunity)
                    .then(response => {
                      this.$store.dispatch('app/toggleTrackingPanel')
                      this.$store.dispatch('trackings/query', {
                        'filters[where][opportunityId][eq]': this.currentOpportunity.id,
                        sort: 'dueDate asc',
                        limit: 1000
                      })
                      this.$store.dispatch('opportunities/query', {
                        ...this.$route.query,
                        'filters[where][customerId][eq]': this.customer.id
                      })
                      this.$store.dispatch('opportunities/get', { id: this.currentOpportunity.id })
                    })
                } else {
                  this.$store.dispatch('app/toggleTrackingPanel')
                  this.$store.dispatch('trackings/query', {
                    'filters[where][opportunityId][eq]': this.currentOpportunity.id,
                    sort: 'dueDate asc',
                    limit: 1000
                  })
                  this.$store.dispatch('opportunities/query', {
                    ...this.$route.query,
                    'filters[where][customerId][eq]': this.customer.id
                  })
                  this.$store.dispatch('opportunities/get', { id: this.currentOpportunity.id })
                }
              })
              .catch(error => {
                this.$notify.error({
                  group: 'app',
                  title: 'Error al crear seguimiento.',
                  message: 'Por favor, vuelve a intentarlo.'
                })
                return Promise.reject(error)
              })
            this.fullscreenLoading = true
            setTimeout(() => {
              this.fullscreenLoading = false
            }, 2000)
          } else {
            this.$notify.error({
              group: 'app',
              title: 'Verifica el formulario.',
              message: 'Por favor, revisa los errores que se indican dentro del formulario.'
            })
            return false
          }
        })
      }
    },
    onChangeStatus () {
      if (this.model.status === 'En Proceso') {
        this.model.dueDate = null
        this.model.completed = false
        this.model.reminder = true
      } else {
        this.model.dueDate = moment().format()
        this.model.reminder = false
      }
    },
    onChangeSelect (val) {
      this.oportunity.reasonRejection = null
      if (val === 'otro') {
        this.other = true
      } else {
        this.oportunity.reasonRejection = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
.trackings-form{
  padding: 0 30px;
  .el-button{
    margin-bottom: 5px;
    box-shadow: 0 3px 6px 0 rgba(#E7120E, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/trackings/trackings-form.vue